import { FC } from 'react';

import { getBannerTextTypography } from 'utils/banner/utils';

import { Text, useBreakpoint } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

interface AdvertisementBanReasonProps {
    singleBanner: boolean;
}

const TrlKeys = {
    part1: 'banner.actions.message.status.banned.tip.part1',
    part2: 'banner.actions.message.status.banned.tip.part2',
    part3: 'banner.actions.message.status.banned.tip.part3',
    fewBanners: 'banner.actions.message.status.banned.tip.fewBanners',
};

export const AdvertisementBanReason: FC<AdvertisementBanReasonProps> = ({ singleBanner }) => {
    const { isMobile } = useBreakpoint();
    const trls = useTrls();

    const typography = getBannerTextTypography(isMobile);

    if (!singleBanner) {
        return <Text typography={typography}>{trls(TrlKeys.fewBanners)}</Text>;
    }

    return (
        <>
            <Text typography={typography}>{trls(TrlKeys.part1)}</Text>
            <Text typography={typography}>{trls(TrlKeys.part2)}</Text>
            <Text typography={typography}>{trls(TrlKeys.part3)}</Text>
        </>
    );
};
